import { L } from 'vue2-leaflet'

var blueIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-blue.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var tealIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-teal.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var redIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-red.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var greenIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-green.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var orangeIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-orange.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var yellowIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-yellow.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var purpleIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-purple.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var greyIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-grey.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

var blackIcon = new L.Icon({
  iconUrl: 'img/icons/map/marker-icon-2x-black.png',
  shadowUrl: 'img/icons/map/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

export default {
  blue: blueIcon,
  teal: tealIcon,
  red: redIcon,
  green: greenIcon,
  orange: orangeIcon,
  yellow: yellowIcon,
  purple: purpleIcon,
  grey: greyIcon,
  black: blackIcon
}
